import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import routes, { renderRoutes } from "./routes";
import "tailwindcss/tailwind.css";
import "./styles/global-theme.css";
import { AuthProvider } from "./contexts/AuthContext";
import { BrandingProvider } from "./contexts/BrandingContext";
import { DefectConfigProvider } from "./contexts/DefectConfigContext";
import { AuthorityProvider } from "./contexts/AuthorityContext";
import '@fontsource/inter';
import './utils/themeInjector'; // Import theme injector
import { ThemeProvider, createTheme } from '@mui/material/styles';

const muiTheme = createTheme({
  typography: {
    fontFamily: "'DM Sans', sans-serif",
  },
});

const App = () => {
  return (
    <>
      <Router>
        <ThemeProvider theme={muiTheme}>
          <BrandingProvider>
            <AuthProvider>
              <DefectConfigProvider>
                <AuthorityProvider>
                  <div className="app">{renderRoutes(routes)}</div>
                </AuthorityProvider>
              </DefectConfigProvider>
            </AuthProvider>
          </BrandingProvider>
        </ThemeProvider>
      </Router>
    </>
  );
};

export default App;
